import Vue from 'vue';

Vue.component('language-links', {
    props: {
        siteHandle: {
            type: String,
        },
    },

    methods: {
        /**
         * Go to given URL with Geomate override cookie set.
         *
         * @param {String} url
         * @param {String} siteName
         */
        switchLanguage(url, siteName) {
            const parsedUrl = this.handleEuRedirect(url, siteName);
            // Set cookie expiration date 7 days in the future (= geomate default)
            const expire = new Date(Date.now() + 7 * 24 * 60 * 60 * 1000);

            const europeOveride =
                siteName === 'default' ? 'mgMotorsEurope' : siteName;

            document.cookie = `RedirectOverride=${europeOveride}; expires=${expire.toUTCString()}; path=/`;
            const urlWithRedirectParam = new URL(parsedUrl);
            const params = new URLSearchParams(urlWithRedirectParam.search);
            params.set('lang', europeOveride);
            urlWithRedirectParam.search = params.toString();

            // Move to URL
            document.location.href = urlWithRedirectParam.toString();
        },

        handleEuRedirect(url, siteName) {
            const searchParams = Object.fromEntries(
                new URLSearchParams(window.location.search).entries(),
            );
            const splitUrl = url.includes('?') ? url.split('?')[0] : url;
            const isRedirectToConfiguratorOrTestdrive =
                'openConfigurator' in searchParams ||
                'openTestdrive' in searchParams;

            if (!isRedirectToConfiguratorOrTestdrive) return `${splitUrl}`;

            return this.handlePageToRedirect(
                searchParams,
                splitUrl,
                siteName,
                'openConfigurator' in searchParams
                    ? 'configurator'
                    : 'request-test-drive',
            );
        },

        handlePageToRedirect(
            searchParams,
            splitUrl,
            siteName,
            pageToRedirectTo,
        ) {
            const isModelInSearchParams = 'model' in searchParams;
            const isGeneralFormInSearchParams =
                'form' in searchParams && searchParams.form === 'general';
            const model =
                siteName === 'mgMotorsGermany' && searchParams.model === 'ehs'
                    ? 'zs-ev'
                    : searchParams.model;

            const isCyberster = searchParams.model == 'cyberster';

            if (isCyberster) {
                return `${this.removePathname(
                    splitUrl,
                )}model/cyberster/configurator/?lang=${siteName}`;
            }

            if (isModelInSearchParams) {
                return `${this.removePathname(
                    splitUrl,
                )}${pageToRedirectTo}/${model}/?lang=${siteName}`;
            }

            if (isGeneralFormInSearchParams) {
                return `${this.removePathname(
                    splitUrl,
                )}${pageToRedirectTo}/?lang=${siteName}`;
            }

            return `${splitUrl}?lang=${siteName}`;
        },

        removePathname(url) {
            // User should be redirected to the configurator regarding the page he is on.
            // So this array contains all the url parts that should be removed from the url so the redirect can work.
            // If any new page is added to the website, it should be added to this array as well.
            // TODO: LOOK INTO WAY NOT TO HARDCODE THIS
            const unallowedUrlParts = [
                'model',
                'brand-history',
                'request',
                'compare',
                'map',
                'ismart',
                'owners',
                'about',
                'faq',
                'contact',
                'partner',
                'privacy-notice',
                'cookie-policy',
                'ismart-eula',
                'impressum',
                'career',
                'newsletter',
                'campaign',
            ];

            if (!unallowedUrlParts.some((urlPart) => url.includes(urlPart))) {
                return url;
            }

            return url.replace(window.location.pathname, '') + '/';
        },
    },
});
